<template>
  <div
    class="kiosk"
    :class="layout"
  >
    <market
      v-for="(market, marketIndex) in markets"
      :key="market.id"
      :index="marketIndex"
      :market="market"
      :layout="layout"
      :tile-count="tileCount"
    />
    <dash-audio-player v-if="audio" class="player" />
  </div>
</template>

<script>
import { getLayoutConfig } from '@/utils/layout';
import { DashAudioPlayer } from '@ibiquity/dashboard.audio-player';
import { mapActions, mapGetters } from 'vuex';
import Market from './_Market';

export default {
  name: 'Main',
  components: {
    Market,
    DashAudioPlayer,
  },
  data() {
    const { layout, audio } = this.$route.query;
    const { tileCount, defaultMarketIds } = getLayoutConfig(layout);
    const marketIds = this.$route.query.marketIds
      ? this.$route.query.marketIds.split(',')
      : defaultMarketIds;
    return {
      layout,
      tileCount,
      marketIds,
      audio,
    };
  },
  computed: {
    ...mapGetters('markets', ['markets']),
    ...mapGetters('playback', ['activeBroadcastId']),
  },
  watch: {
    activeBroadcastId() {
      if (this.activeBroadcastId) {
        this.subscribe(this.activeBroadcastId);
      } else {
        this.unsubscribe();
      }
    },
  },
  created() {
    this.loadMarkets(this.marketIds);
  },
  methods: {
    ...mapActions('markets', ['loadMarkets', 'subscribe', 'unsubscribe']),
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/variables";
@import "~@/assets/scss/layout";

.kiosk {
  @extend %layout;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  padding: 0.25vh;
  color: $white;

  &.landscape-4k {
    padding: 2.2vw 2vw;
    grid-gap: 0.08vw 0.15vw;
  }

  &.landscape-4k-4m {
    padding: 0.6vw 2.3vw;
  }
}

.player {
  display: none;
}
</style>
